import { useCallback, useEffect, useState } from "react";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  phoneNumberValidation,
} from "../../Common/Validations";
import { addCustomer } from "../../Redux/Slice/Customers/AddCustomerSlice";
import { useDispatch, useSelector } from "react-redux";
import { ErrorModel } from "../../Model/ErrorModel";
import { setCustomer } from "../../Redux/Slice/Customers/CustomerSlice";
import { useNavigate } from "react-router-dom";
import { getPlans } from "../../Redux/Slice/Plans/GetPlansListSlice";
import { getStateFromZipcode } from "../../Redux/Slice/Common/GetStateFromZipcode";
import { debounce } from "../../Common/debounce";
import { ConfirmModel } from "../../Model/ConfirmModel";
import useDebounce from "../../Common/useDebounce";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { ALL_CALLING_CODES } from "../../Common/Constants";
import { maskNoByCallingCode } from "../../Common/utils";
import CountryPhoneInput from "../../Common/CountryPhoneInput";

export const CustomerDetails = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pinCOde, setPincode] = useState("");
  const formData = props?.customerFormData;
  const setFormData = props?.setCustomerFormData;
  const [formError, setFormError] = useState({
    phoneError: "",
    zipCodeError: "",
  });
  const debouncedZipCode = useDebounce(pinCOde, 500);
  const [emailError, setEmailError] = useState("");
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasChanged, setHasChanged] = useState(false);
  const [plansList, setPlansList] = useState([]);
  const [confirmModel, setCOnfirmModel] = useState(false);

  const plans = useSelector((state) => state.plansList.planDetails);

  useEffect(() => {
    if (props?.isEdit === true) {
      const data = props.customerDetails;
      setPincode(data?.address?.zipCode);
      setFormData({
        id: data.id ?? "",
        companyName: data.companyName ?? "",
        email: data.email ?? "",
        address: {
          address: data?.address?.address ?? "",
          state: data?.address?.state ?? "",
          city: data?.address?.city ?? "",
          country: data?.address?.country ?? "",
          zipcode: data?.address?.zipCode ?? "",
        },
        countryCallingCode: data.countryCallingCode
          ? data.countryCallingCode
          : "+61",
        phoneNumber: data?.phoneNumber
          ? data.phoneNumber
          : "",
        isDefaultEmail: data?.isDefaultEmail ?? false,
      });
    }
  }, [props.customerDetails]);

  useEffect(() => {
    dispatch(getPlans());
  }, []);

  useEffect(() => {
    if (plans) {
      setPlansList(plans.data);
    }
  }, [plans]);
  const handleCancel = () => {
    dispatch(setUnsavedChanges(false));
    setCOnfirmModel(false);
    navigate("/customers");
  };

  const handleChange = (e) => {
    let { name, value, type, checked } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    value = value.trimStart();
    if (name === "address") {
      setFormData((prevData) => ({
        ...prevData,
        address: { ...formData.address, address: value },
      }));
    } else if (name === "email") {
      value = value.trimEnd();
      setFormData((prevData) => ({ ...prevData, [name]: value.trimStart() }));
      const isValid = emailValidation(value);
      if (isValid || value === "") {
        setEmailError("");
      } else {
        setEmailError("Please enter valid email");
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type == "checkbox" ? checked : value,
      }));
    }
  };

  const handleCountryCodeChange = async (e) => {
    const { name, value } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    let formatted = formData.phoneNumber;
    setFormData({ ...formData, [name]: value, phoneNumber: formatted });
    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
    const rawDigits = formData.phoneNumber.replace(/\D/g, "");
    const isValid = phoneNumberValidation(rawDigits, value);
    setFormError({
      ...formError,
      phoneError:
        isValid || value === ""
          ? ""
          : rawDigits.length < minDigits
          ? `Phone number must be at least ${minDigits} digits long.`
          : "Please enter a valid phone number",
    });
  };

  const handlePhoneChange = async (e) => {
    let { name, value } = e.target;
    handlePhoneNoChange(
      e,
      formData.countryCallingCode,
      () => setFormData({ ...formData, [name]: value }),
      (newError) => setFormError({ ...formError, phoneError: newError }),
      (isChanged) => {
        setHasChanged(isChanged);
        dispatch(setUnsavedChanges(true));
      },
      false
    );
  };

  const handleSubmit = async () => {
    props.setSelectedTab(2);
  };

  const getStateDetails = async (pincode) => {
    if (pincode > 0) {
      const result = await dispatch(getStateFromZipcode(pincode));
      if (
        getStateFromZipcode.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setFormData((prevData) => ({
          ...prevData,
          address: {
            ...prevData.address,
            country: result?.payload?.data?.country,
            city: result?.payload?.data?.city,
            state: result?.payload?.data?.state,
            zipCode: pincode,
          },
        }));
        setFormError({ ...formError, zipCodeError: "" });
      } else {
        setFormData((prevData) => ({
          ...prevData,
          address: {
            ...prevData.address,
            country: "",
            city: "",
            state: "",
            zipCode: pincode,
          },
        }));
        if (pincode === "") {
          setFormError({ ...formError, zipCodeError: "" });
        } else {
          setFormError({
            ...formError,
            zipCodeError: "Invalid ZipCode",
          });
        }
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          country: "",
          city: "",
          state: "",
          zipCode: pincode,
        },
      }));
    }
  };
  const debouncedGeStateList = useCallback(debounce(getStateDetails, 500), [
    debouncedZipCode,
  ]);

  const handleChangeCustomerZipcode = async (e) => {
    const { name, value } = e.target;
    const formattedValue = value.replace(/\D/g, "");
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    setPincode(formattedValue);
    debouncedGeStateList(formattedValue);
    if (!formattedValue || formattedValue.length === 0) {
      setFormError((prev) => ({ ...prev, zipCodeError: "" }));
    }
  };
  const handelNo = () => {
    setCOnfirmModel(false);
  };

  return (
    <div
      className={
        props.selectedTab === 1
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleCancel}
          yes={"Yes"}
          no={"No"}
          onReject={handelNo}
          title="Update Changes!"
          message="Changes made will not be saved. Are you sure you want to leave the page?"
        />
      ) : (
        ""
      )}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <h1 className="form__section__title">Company Details</h1>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="companyName" className="form__label">
                    Company Name <span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    onChange={handleChange}
                    value={formData.companyName}
                    className="form__input form__input--sm"
                    placeholder="Company Name"
                  />
                </div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="email" className="form__label">
                    Email
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    maxLength={100}
                    onChange={handleChange}
                    value={formData.email}
                    className={"form__input form__input--sm"}
                    placeholder="Email"
                  />
                  <div className="form__error">{emailError}</div>
                </div>
                {props?.planType == "standard" ||
                props?.planType == "pro" ||
                props?.planType == "enterprise" ? (
                  <p className="para para--right">
                    <div className="form__checkbox__option m_0">
                      <input
                        type="checkbox"
                        id="isDefaultEmail"
                        className="form__checkbox__input"
                        value={formData?.isDefaultEmail}
                        name="isDefaultEmail"
                        checked={formData?.isDefaultEmail ?? false}
                        onChange={handleChange}
                      />
                      <label
                        for="isDefaultEmail"
                        className="form__checkbox__label"
                      >
                        Allow to send Emails to Contacts
                      </label>
                    </div>
                  </p>
                ) : null}
              </div>
            </div>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="phonenumber" className="form__label">
                    Phone Number
                  </label>
                  <CountryPhoneInput
                    countryCodeFieldName="countryCallingCode"
                    phoneFieldName="phoneNumber"
                    countryCode={formData.countryCallingCode}
                    phoneNumber={formData.phoneNumber}
                    onCountryChange={handleCountryCodeChange}
                    onPhoneChange={handlePhoneChange}
                  />
                  <div className="form__error">{formError.phoneError}</div>
                </div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="email" className="form__label">
                    Address
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="address"
                    onChange={handleChange}
                    value={formData.address.address}
                    className="form__input form__input--sm"
                    placeholder="Address"
                  />
                </div>
              </div>
            </div>
            <div className="formRow formRow__2">
              <div className="formRow formRow__4">
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgZipCode" className="form__label">
                      Zip Code
                    </label>
                    <input
                      type="text"
                      id="orgZipCode"
                      name="zipCode"
                      value={pinCOde}
                      onChange={handleChangeCustomerZipcode}
                      className="form__input form__input--sm"
                      placeholder="Zip Code"
                      maxLength={4}
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgCity" className="form__label">
                      City
                    </label>
                    <input
                      type="text"
                      id="orgCity"
                      name="city"
                      disabled
                      value={formData?.address?.city}
                      onChange={handleChange}
                      className="form__input form__input--sm form__input--disabled"
                      placeholder="City"
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgState" className="form__label">
                      State
                    </label>
                    <input
                      type="text"
                      id="orgState"
                      name="state"
                      value={formData?.address?.state}
                      onChange={handleChange}
                      disabled
                      className="form__input form__input--sm form__input--disabled"
                      placeholder="State"
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgCountry" className="form__label">
                      Country
                    </label>
                    <input
                      type="text"
                      id="orgCountry"
                      name="country"
                      value={formData?.address?.country}
                      onChange={handleChange}
                      disabled
                      className="form__input form__input--sm form__input--disabled"
                      placeholder="Country"
                    />
                  </div>
                </div>
                <div className="form__error">{formError.zipCodeError}</div>
              </div>
            </div>
            <div className="btn__group">
              <button
                className="btn btn__white"
                onClick={() => {
                  if (hasChanged) {
                    setCOnfirmModel(true);
                  } else {
                    dispatch(setUnsavedChanges(false));
                    navigate("/customers");
                  }
                }}
                type="button"
              >
                Cancel
              </button>
              {!props.isEdit ? (
                <button
                  className="btn btn__primary"
                  onClick={handleSubmit}
                  disabled={
                    formData.companyName === "" ||
                    formError.phoneError ||
                    formError.zipCodeError
                  }
                  type="submit"
                >
                  Next
                </button>
              ) : (
                <button
                  className="btn btn__primary"
                  onClick={() => props.handleSubmit(formData)}
                  disabled={
                    !hasChanged ||
                    formData.companyName === "" ||
                    formData.planId === "" ||
                    formError.phoneError ||
                    formError.zipCodeError
                  }
                  type="submit"
                >
                  Update
                </button>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
